module.exports = __webpack_public_path__ + "img/recommend-sentosa.82fbedae.svg";